/**
@format
@flow
*/
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import ActionTypes from '@ziynx/action-types';
import type { MediaState, UploadReferenceId } from '@ziynx/flow-types/media';

const UploadManager = (): null => {
  const mediaService: MediaState = useSelector(({ media }) => media);

  const dispatch = useDispatch();

  useEffect(() => {
    const { s3UploadsInProgress, uploadsQueue } = mediaService;

    if (!s3UploadsInProgress?.length || !uploadsQueue?.length) {
      return;
    }

    mediaService?.uploadsQueue?.forEach(
      (uploadReferenceId: UploadReferenceId) => {
        s3UploadsInProgress?.forEach(() => {
          dispatch({
            type: ActionTypes.media.checkUploadStatus.START,
            mediaUploadReference: mediaService[uploadReferenceId],
          });
        });
      },
    );
  }, [mediaService?.uploadsQueue]);

  return null;
};

export default UploadManager;
